import React, { useCallback } from 'react'

import { useSelectedTrial } from 'src/features/auth/context'
import type { components } from 'src/lib/api-client/schema.gen'
import { useMirohaToast } from 'src/lib/chakra-theme/components/toast/use-miroha-toast'

import { CreateModal } from './create-modal'
import { create } from '../../../../../../../entities/template-folder/request'
import { useRequestState } from '../../../../../../../server/use-request-state'
import { useTemplateEntities } from '../../../template-entities-context'

type Props = {
  v2: boolean
  onClose: () => void
}

const useSubmit = () => {
  const { selectedTrial } = useSelectedTrial()
  const trialUid = selectedTrial.uid

  const { requesting, requestDone, requestStarted } = useRequestState()
  const { upsertTemplateFolder } = useTemplateEntities()
  const toast = useMirohaToast()
  const request = useCallback(
    async (params: {
      name: string
      isFollowup?: boolean
      observationType?: components['schemas']['enums.ObservationType']
    }) => {
      try {
        requestStarted()

        const res = await create({
          trialUid,
          name: params.name,
          isFollowup: params.isFollowup,
          observationType: params.observationType,
        })
        upsertTemplateFolder(res)
        toast({
          status: 'success',
          title: 'フォルダを作成しました',
        })
        requestDone()
      } catch (error) {
        toast({
          status: 'error',
          title: error.message,
        })
      }
    },
    [toast, upsertTemplateFolder, requestDone, requestStarted, trialUid],
  )

  return { request, requesting }
}

export const ModalContainer: React.FC<Props> = props => {
  const { request, requesting } = useSubmit()
  const onSubmit = useCallback(
    async (params: {
      name: string
      isFollowup?: boolean
      observationType?: components['schemas']['enums.ObservationType']
    }) => {
      await request(params)
      props.onClose()
    },
    [props, request],
  )

  return (
    <CreateModal
      v2={props.v2}
      isOpen={true}
      onClose={props.onClose}
      onSubmit={onSubmit}
      requesting={requesting}
    />
  )
}
